<router-outlet></router-outlet>
<app-floating-help-button *ngIf="showFloatingHelp"></app-floating-help-button>
